import { render } from "./SocialBoardCards.vue?vue&type=template&id=50f42526"
import script from "./SocialBoardCards.vue?vue&type=script&lang=js"
export * from "./SocialBoardCards.vue?vue&type=script&lang=js"

import "./SocialBoardCards.vue?vue&type=style&index=0&id=50f42526&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__